// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal { /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
  max-width: 400px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative; /* Ensure the close button stays in place */
}

.close {
  color: #aaa;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group input {
  width: 100%;
  padding: 10px;
  margin-bottom: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 16px;
}

.submit-button {
  width: 100%;
  background: linear-gradient(
    to right,
    var(--primary-color),
    var(--primary-color-light)
  );
  color: white;
  border: none;
  padding: 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add a slight shadow for depth */
  transition: background 0.3s ease, transform 0.3s ease; /* Smooth background and transform transition */
}

.submit-button:hover {
  background: linear-gradient(
    to right,
    var(--primary-color-dark),
    var(--primary-color)
  );
  transform: translateY(-2px); /* Slight lift effect on hover */
}

.submit-button:active {
  transform: translateY(0); /* Reset lift effect on click */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Reduce shadow on click */
}

.signup-link {
  text-align: center;
  margin-top: 15px;
}

.signup-link a {
  color: var(--primary-color);
  text-decoration: none;
}

.signup-link a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Login.css"],"names":[],"mappings":"AAAA,SACiB,sBAAsB;EACrC,eAAe,EAAE,kBAAkB;EACnC,aAAa,EAAE,eAAe;EAC9B,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,4BAA4B;EAC5C,8BAA8B,EAAE,mBAAmB;EACnD,oCAAoC,EAAE,qBAAqB;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,UAAU,EAAE,oDAAoD;EAChE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB,EAAE,2CAA2C;AACjE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX;;;;GAIC;EACD,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wCAAwC,EAAE,kCAAkC;EAC5E,qDAAqD,EAAE,+CAA+C;AACxG;;AAEA;EACE;;;;GAIC;EACD,2BAA2B,EAAE,gCAAgC;AAC/D;;AAEA;EACE,wBAAwB,EAAE,+BAA+B;EACzD,wCAAwC,EAAE,2BAA2B;AACvE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".modal {\r\n  display: flex; /* Hidden by default */\r\n  position: fixed; /* Stay in place */\r\n  z-index: 1000; /* Sit on top */\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto; /* Enable scroll if needed */\r\n  background-color: rgb(0, 0, 0); /* Fallback color */\r\n  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.modal-content {\r\n  background-color: #fefefe;\r\n  padding: 20px;\r\n  border: 1px solid #888;\r\n  width: 80%; /* Could be more or less, depending on screen size */\r\n  max-width: 400px;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  position: relative; /* Ensure the close button stays in place */\r\n}\r\n\r\n.close {\r\n  color: #aaa;\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n}\r\n\r\n.close:hover,\r\n.close:focus {\r\n  color: black;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  font-weight: bold;\r\n}\r\n\r\n.form-group input {\r\n  width: 100%;\r\n  padding: 10px;\r\n  margin-bottom: 5px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  box-sizing: border-box;\r\n  font-size: 16px;\r\n}\r\n\r\n.submit-button {\r\n  width: 100%;\r\n  background: linear-gradient(\r\n    to right,\r\n    var(--primary-color),\r\n    var(--primary-color-light)\r\n  );\r\n  color: white;\r\n  border: none;\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add a slight shadow for depth */\r\n  transition: background 0.3s ease, transform 0.3s ease; /* Smooth background and transform transition */\r\n}\r\n\r\n.submit-button:hover {\r\n  background: linear-gradient(\r\n    to right,\r\n    var(--primary-color-dark),\r\n    var(--primary-color)\r\n  );\r\n  transform: translateY(-2px); /* Slight lift effect on hover */\r\n}\r\n\r\n.submit-button:active {\r\n  transform: translateY(0); /* Reset lift effect on click */\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Reduce shadow on click */\r\n}\r\n\r\n.signup-link {\r\n  text-align: center;\r\n  margin-top: 15px;\r\n}\r\n\r\n.signup-link a {\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n}\r\n\r\n.signup-link a:hover {\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
